import React, { Component } from 'react';
import { Chart } from "react-google-charts";

class Curve extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		return (
			<iframe src={"//cdn.grade.se/composer/version-independent/client-resources/madrs/curve.htm?mean=" + this.props.mean + "&std=" + this.props.std+ "&userresult=" + this.props.userResult} ></iframe>
		);
	}
}

export default Curve;


// WEBPACK FOOTER //
// ./src/components/Curve.js